//用于管理news模块的小仓库
import { defineStore } from 'pinia'  //引入创建pinia的方法

import { reqGetKnowledgeList, reqGetRecommendedKnowledge, reqKnowledge } from '@/api'  //引入发送请求获取数据的方法

export const useKnowledgeStore = defineStore('knowledge', {
    //state：仓库存储数据的地方
    state: () => ({
				knowledgeList: [],    //新闻列表数据
        knowledgeRecommended: []  //新闻推荐数据
    }),

    //action：处理action，可以书写自己的业务逻辑,可以直接修改state
    actions: {
        //新闻列表数据
        async getKnowledgeList() {
            let result = await reqGetKnowledgeList()
						console.log('result',result)
            if (result.code == 200) {
                this.knowledgeList = result.data
            }
        },
        //行业动态数据
        async getKnowledge() {
            let result = await reqKnowledge()
            if (result.code == 200) {
                this.knowledgeList = result.data
            }
        },
        //新闻推荐数据
        async getKnowledgeRecommended() {
            let result = await reqGetRecommendedKnowledge()
						console.log('result',result)
            if (result.code == 200) {
                this.knowledgeRecommended = result.data
            }
        }
    },

    //getters：可以理解为计算属性，用于简化仓库属性。让组件获取仓库数据更便捷
    getters: {
        homeKnowledgeList(state) {
            return state.knowledgeList.splice(0, 3)
        }
    }
})